/* Meine Garage: Fahrzeuge merken (mehrere, mit Spitzname und Foto) und passende Teile markieren.
 *
 * Alles bleibt in diesem Browser (localStorage). Das Foto wird nur lokal verkleinert und gespeichert,
 * nichts wird hochgeladen. Die Garage aendert sich nie von selbst: Nur was der Kunde in der Garage waehlt,
 * wird uebernommen.
 *
 * Zuordnung ueber die Produkt-Tags: Ein Produkt gilt als passend, wenn einer seiner Tags einen der
 * Baureihen-Codes des Fahrzeugs als ganzes Wort enthaelt (z. B. "G20 / G21 Artikel").
 * Neue Fahrzeuge: in snippets/garage-vehicles.liquid ergaenzen.
 */
(() => {
  if (window.BGGarage) return;

  const KEY = 'bg-garage-v2';
  const LEGACY_KEY = 'bg-garage';
  const MAX_CARS = 8;

  /* Fahrzeugliste (eine Quelle: snippets/garage-vehicles.liquid) ------------- */
  // Zeile: Marke | Gruppe | Bezeichnung | Baureihen-Codes (nur alte BMW-Tags) | Name | ID | Flags (je optional)
  const readDefs = () => {
    const el = document.getElementById('garage-vehicles-data');
    if (!el) return [];
    return el.textContent.split('\n')
      .map((line) => line.trim())
      .filter((line) => line.split('|').length >= 4)
      .map((line) => {
        const [brand, group, label, codes, name, id, flags] = line.split('|').map((part) => part.trim());
        return [brand, group, label, (codes || '').split(',').map((c) => c.trim()).filter(Boolean), name, id, flags || ''];
      });
  };

  const slug = (text) => text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  const VEHICLES = readDefs().map(([brand, group, label, codes, name, explicitId, flags]) => {
    const fullName = name || `${brand} ${group} ${label}`;
    return {
      // BMW-IDs bleiben wie frueher (gespeicherte Garagen), andere Marken bekommen die Marke im ID
      id: explicitId || (brand === 'BMW' ? slug(`${group}-${label}`) : slug(`${brand}-${group}-${label}`)),
      legacy: /\blegacy\b/.test(flags),
      brand,
      group,
      label,
      codes,
      name: fullName,
      tag: `Fahrzeug: ${fullName}`,
      badge: codes[0] || label.split(' / ')[0],
      short: brand === 'BMW' ? label.split(' / ').slice(0, 2).join(' / ') : `${group} ${label.split(' / ')[0]}`
    };
  });

  const BRANDS = [...new Set(VEHICLES.map((v) => v.brand))];

  const CODE_RE = /(^|[^a-z0-9])([efgiu]\d{2}|e9x)(?=$|[^a-z0-9])/gi;
  const byId = (id) => VEHICLES.find((v) => v.id === id) || null;

  const norm = (text) => String(text).trim().toLowerCase();

  // Passt, wenn: Tag "Fahrzeug: <Name>", Tag "Fahrzeug: <Marke> alle" oder (BMW, alt) ein Baureihen-Code in einem Tag
  const fits = (tags, vehicle) => {
    if (!vehicle || !tags.length) return false;
    const lower = tags.map(norm);
    if (lower.includes(norm(vehicle.tag)) || lower.includes(norm(`Fahrzeug: ${vehicle.brand} alle`))) return true;
    // Hat das Produkt genaue "Fahrzeug:"-Tags, zaehlen nur diese (alte Baureihen-Codes werden ignoriert)
    if (lower.some((t) => t.startsWith('fahrzeug:'))) return false;
    if (!vehicle.codes.length) return false;
    return vehicle.codes.some((code) => {
      const rx = new RegExp(`(^|[^a-z0-9])${code.toLowerCase()}($|[^a-z0-9])`);
      return lower.some((t) => rx.test(t));
    });
  };

  /* Zustand ------------------------------------------------------------------ */
  const newUid = () => `c${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
  const newCar = (vehicleId) => ({ uid: newUid(), vehicleId, nick: '', photo: '', added: Date.now() });

  const load = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY));
      if (saved && Array.isArray(saved.cars)) return saved;
    } catch (e) { /* weiter mit Migration */ }
    try {
      const old = JSON.parse(localStorage.getItem(LEGACY_KEY));
      if (old && old.id && byId(old.id)) {
        const car = newCar(old.id);
        return { v: 2, active: car.uid, cars: [car] };
      }
    } catch (e) { /* leer starten */ }
    return { v: 2, active: null, cars: [] };
  };

  let state = load();

  const validCars = () => state.cars.filter((c) => byId(c.vehicleId));
  const activeCar = () => {
    const cars = validCars();
    return cars.find((c) => c.uid === state.active) || cars[0] || null;
  };

  const persist = () => {
    try {
      localStorage.setItem(KEY, JSON.stringify(state));
      return true;
    } catch (e) {
      return false;
    }
  };

  /* Garage-Level: Sterne fuer ein vollstaendiges Profil ------------------------ */
  const GOALS = [
    { text: 'Wähle dein Fahrzeug', done: (c) => c.length >= 1 },
    { text: 'Gib deinem Auto einen Namen', done: (c) => c.some((x) => x.nick.trim()) },
    { text: 'Füge ein Foto hinzu', done: (c) => c.some((x) => x.photo) },
    { text: 'Füge ein zweites Fahrzeug hinzu', done: (c) => c.length >= 2 },
    { text: 'Gib auch deinem zweiten Auto ein Foto', done: (c) => c.filter((x) => x.photo).length >= 2 }
  ];

  const levelOf = (cars) => {
    const done = GOALS.map((g) => g.done(cars));
    const stars = done.filter(Boolean).length;
    const next = GOALS.find((g, i) => !done[i]);
    return { stars, total: GOALS.length, next: next ? next.text : '' };
  };

  /* Oeffentliche Schnittstelle --------------------------------------------------- */
  // Meldet nur das Fahrzeug (keine Spitznamen, keine Fotos). Ohne Einwilligung sendet BGTrack nichts.
  const track = (action, vehicle) => {
    if (window.BGTrack && vehicle) window.BGTrack.event('garage', { action, vehicle_id: vehicle.id, vehicle: vehicle.name, brand: vehicle.brand });
  };

  const store = {
    vehicles: VEHICLES,
    brands: BRANDS,
    isUniversal: (tags) => tags.some((t) => t.trim().toLowerCase() === 'passform: universal'),
    fits,
    vehiclesFor: (tags) => VEHICLES.filter((v) => fits(tags, v)),
    cars: validCars,
    activeCar,
    level: () => levelOf(validCars()),
    get() {
      const car = activeCar();
      return car ? byId(car.vehicleId) : null;
    },
    vehicleOf: (car) => byId(car.vehicleId),
    emit() {
      persist();
      document.dispatchEvent(new CustomEvent('garage:change', { detail: { vehicle: store.get() } }));
    },
    add(vehicleId) {
      if (!byId(vehicleId)) return null;
      if (validCars().length >= MAX_CARS) return null;
      const car = newCar(vehicleId);
      state.cars.push(car);
      state.active = car.uid;
      this.emit();
      track('add', byId(vehicleId));
      return car;
    },
    // Kompatibel zu frueherem Aufruf: Fahrzeug aktivieren, ggf. neu anlegen
    set(vehicleId) {
      const existing = validCars().find((c) => c.vehicleId === vehicleId);
      if (existing) {
        state.active = existing.uid;
        this.emit();
        return byId(vehicleId);
      }
      return this.add(vehicleId) ? byId(vehicleId) : null;
    },
    replace(uid, vehicleId) {
      const car = state.cars.find((c) => c.uid === uid);
      if (!car || !byId(vehicleId)) return null;
      car.vehicleId = vehicleId;
      this.emit();
      track('replace', byId(vehicleId));
      return car;
    },
    activate(uid) {
      if (!state.cars.some((c) => c.uid === uid)) return;
      state.active = uid;
      this.emit();
    },
    remove(uid) {
      const removed = state.cars.find((c) => c.uid === uid);
      if (removed) track('remove', byId(removed.vehicleId));
      state.cars = state.cars.filter((c) => c.uid !== uid);
      if (state.active === uid) state.active = state.cars.length ? state.cars[0].uid : null;
      this.emit();
    },
    // silent: nur speichern, kein Neuzeichnen (beim Tippen des Spitznamens)
    update(uid, patch, silent) {
      const car = state.cars.find((c) => c.uid === uid);
      if (!car) return false;
      Object.assign(car, patch);
      const saved = persist();
      if (!silent) document.dispatchEvent(new CustomEvent('garage:change', { detail: { vehicle: store.get() } }));
      return saved;
    },
    clear() {
      const car = activeCar();
      if (car) this.remove(car.uid);
    },
    // Fahrzeug anhand eines Textes finden (z. B. "BMW M4 G82 G83"), ohne die Garage zu veraendern.
    // BMW: ueber Baureihen-Codes. Andere Marken: nur, wenn genau ein Fahrzeug eindeutig passt.
    findFromText(text) {
      const found = [];
      String(text || '').replace(CODE_RE, (m, pre, code) => { found.push(code.toUpperCase()); return m; });
      const words = new Set(norm(text).split(/[^a-z0-9]+/).filter(Boolean));
      if (found.length) {
        // BMW: Code-Treffer plus Karosserie-Woerter (z. B. "Limousine"); bei Gleichstand lieber nichts vorschlagen
        const scored = VEHICLES.filter((v) => !v.legacy && v.codes.length).map((v) => {
          const codeHits = found.filter((c) => v.codes.includes(c)).length;
          if (!codeHits) return { v, score: 0 };
          const bodyWords = norm(v.label).split(/[^a-z0-9]+/).filter((w) => w && !/^([efgiu]\d{2}|e9x|\d)/.test(w));
          return { v, score: codeHits + bodyWords.filter((w) => words.has(w)).length };
        }).filter((x) => x.score > 0).sort((x, y) => y.score - x.score);
        if (scored.length) return scored.length === 1 || scored[0].score > scored[1].score ? scored[0].v : null;
      }
      const matches = VEHICLES.filter((v) => !v.legacy && !v.codes.length
        && norm(`${v.group} ${v.label}`).split(/[^a-z0-9]+/).filter(Boolean).every((w) => words.has(w))
        && norm(v.brand).split(/[^a-z0-9]+/).filter(Boolean).some((w) => words.has(w)));
      return matches.length === 1 ? matches[0] : null;
    },
    open() {
      const toggle = document.querySelector('[data-garage-toggle]');
      if (toggle && toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
    }
  };

  window.BGGarage = store;

  /* Hilfsfunktionen --------------------------------------------------------------- */
  const esc = (text) => String(text).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const safePhoto = (src) => (typeof src === 'string' && src.startsWith('data:image/jpeg;base64,') ? src : '');
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const CHECK_ICON = '<svg aria-hidden="true" viewBox="0 0 24 24" width="14" height="14"><path fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  const STAR_ICON = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M12 2.8l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.6l-5.8 3.1 1.1-6.5L2.6 9.6l6.5-.9z"/></svg>';
  const CAMERA_ICON = '<svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M4 8.5A1.5 1.5 0 0 1 5.5 7h2l1.2-2h6.6l1.2 2h2A1.5 1.5 0 0 1 20 8.5v9A1.5 1.5 0 0 1 18.5 19h-13A1.5 1.5 0 0 1 4 17.5z"/><circle cx="12" cy="13" r="3.4" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
  const CAR_ART = '<svg class="garage__art" viewBox="0 0 140 60" aria-hidden="true"><path d="M8 44c0-4 4-6 10-7l12-7c6-5 14-8 26-8h22c10 0 18 6 26 12l14 3c5 1 8 4 8 9v4H8z" fill="currentColor" opacity=".9"/><path d="M40 30c5-4 11-6 20-6h18c6 0 12 4 17 9H36z" fill="#0d0f12" opacity=".55"/><circle cx="38" cy="50" r="9" fill="#0d0f12"/><circle cx="38" cy="50" r="4.2" fill="currentColor" opacity=".55"/><circle cx="106" cy="50" r="9" fill="#0d0f12"/><circle cx="106" cy="50" r="4.2" fill="currentColor" opacity=".55"/></svg>';

  const processPhoto = (file) => new Promise((resolve, reject) => {
    if (!file || !/^image\//.test(file.type)) { reject(new Error('Bitte wähle ein Bild aus.')); return; }
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, 900 / Math.max(img.width, img.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(img.width * scale));
      canvas.height = Math.max(1, Math.round(img.height * scale));
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      let quality = 0.82;
      let data = canvas.toDataURL('image/jpeg', quality);
      while (data.length > 380000 && quality > 0.4) {
        quality -= 0.1;
        data = canvas.toDataURL('image/jpeg', quality);
      }
      resolve(data);
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Das Bild konnte nicht gelesen werden.')); };
    img.src = url;
  });

  const burst = (host) => {
    if (!host || reduceMotion()) return;
    for (let i = 0; i < 22; i += 1) {
      const spark = document.createElement('span');
      spark.className = `garage__spark garage__spark--${i % 3}`;
      spark.textContent = i % 2 === 0 ? '★' : '';
      host.append(spark);
      const angle = Math.random() * Math.PI * 2;
      const dist = 60 + Math.random() * 110;
      const dx = Math.cos(angle) * dist;
      const dy = Math.sin(angle) * dist - 30;
      spark.animate([
        { transform: 'translate(-50%, -50%) scale(0.3) rotate(0deg)', opacity: 1 },
        { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) scale(1) rotate(${Math.random() * 360}deg)`, opacity: 0 }
      ], { duration: 850 + Math.random() * 450, easing: 'cubic-bezier(.2,.8,.2,1)' }).onfinish = () => spark.remove();
    }
  };

  /* Fahrzeugunabhaengige Produkte (Pflege, Ambiente, Halter, Gutscheine ...): Tag "Passform: Universal" */
  const isUniversalTags = (tags) => tags.some((t) => t.trim().toLowerCase() === 'passform: universal');

  /* Badges auf Produktkarten ----------------------------------------------------- */
  const applyBadges = () => {
    const vehicle = store.get();
    applyFitment(vehicle);
    document.querySelectorAll('product-card[data-garage-tags]').forEach((card) => {
      const tags = card.dataset.garageTags.split('|');
      const universal = card.hasAttribute('data-garage-universal') || isUniversalTags(tags);
      let kind = null;
      if (vehicle) {
        if (universal) kind = 'universal';
        else if (fits(tags, vehicle)) kind = 'fit';
      }

      let badge = card.querySelector('.garage-fit');
      if (!kind) {
        if (badge) badge.remove();
        card.classList.remove('is-garage-fit');
        return;
      }

      if (badge && badge.dataset.kind !== kind) {
        badge.remove();
        badge = null;
      }
      if (!badge) {
        const media = card.querySelector('.card__media');
        if (!media) return;
        badge = document.createElement('span');
        badge.className = `garage-fit${kind === 'universal' ? ' garage-fit--universal' : ''}`;
        badge.dataset.kind = kind;
        badge.innerHTML = kind === 'universal'
          ? '<span>Fahrzeugübergreifend</span>'
          : `${CHECK_ICON}<span>Passt für dein Fahrzeug</span>`;
        media.append(badge);
      }
      badge.title = kind === 'universal' ? 'Nicht an ein bestimmtes Fahrzeug gebunden' : `Für ${vehicle.name} gelistet`;
      card.classList.toggle('is-garage-fit', kind === 'fit');
    });
  };

  /* Passform-Block auf der Produktseite (snippets/product-fitment.liquid) ------------ */
  function applyFitment(vehicle) {
    document.querySelectorAll('[data-fitment]:not([data-universal])').forEach((block) => {
      const status = block.querySelector('[data-fitment-status]');
      const button = block.querySelector('[data-fitment-open]');
      if (!status) return;

      block.classList.remove('is-fit', 'is-nofit', 'is-neutral');
      status.textContent = '';

      if (!vehicle) {
        block.classList.add('is-neutral');
        status.textContent = 'Prüfe die Passform für dein Fahrzeug.';
        if (button) button.textContent = 'Fahrzeug wählen';
        return;
      }

      const isFit = fits(block.dataset.garageTags.split('|'), vehicle);
      block.classList.add(isFit ? 'is-fit' : 'is-nofit');
      const strong = document.createElement('strong');
      strong.textContent = vehicle.name;

      if (isFit) {
        status.innerHTML = CHECK_ICON;
        status.append(' Für dein Fahrzeug gelistet: ', strong);
      } else {
        status.append('Für ', strong, ' nicht gelistet. Bitte prüfe die Passform oder schreib uns kurz.');
      }
      if (button) button.textContent = 'Ändern';
    });
  }

  let badgeTimer;
  const scheduleBadges = () => {
    clearTimeout(badgeTimer);
    badgeTimer = setTimeout(applyBadges, 120);
  };

  /* Widget im Header -------------------------------------------------------------- */
  class GarageWidget extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-garage-toggle]');
      this.labelEl = this.querySelector('[data-garage-label]');
      this.open = false;
      this.pickerMode = null; // null | 'add' | 'replace'
      this.brand = null;
      this.tab = null;
      this.term = '';
      this.lastStars = store.level().stars;

      this.buildPanel();
      this.button.addEventListener('click', () => this.toggle());
      this.backdrop.addEventListener('click', () => this.close());
      this.panel.addEventListener('click', (e) => this.onClick(e));
      this.panel.addEventListener('input', (e) => this.onInput(e));
      this.panel.addEventListener('change', (e) => this.onChange(e));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.open) this.close(true); });
      document.addEventListener('garage:change', () => this.render());
      window.addEventListener('storage', (e) => {
        if (e.key === KEY) { state = load(); this.render(); }
      });
      window.addEventListener('resize', () => this.open && this.position());
      window.addEventListener('scroll', () => this.open && this.position(), { passive: true });

      this.render();
    }

    buildPanel() {
      this.backdrop = document.createElement('div');
      this.backdrop.className = 'garage__backdrop';
      this.backdrop.hidden = true;

      this.panel = document.createElement('div');
      this.panel.className = 'garage__panel';
      this.panel.id = 'garage-panel';
      this.panel.setAttribute('role', 'dialog');
      this.panel.setAttribute('aria-label', 'Meine Garage');
      this.panel.hidden = true;
      this.panel.innerHTML = `
        <div class="garage__top">
          <p class="garage__brand"><span class="garage__brand-dot"></span>Meine Garage</p>
          <button type="button" class="garage__close" data-close aria-label="Schließen">
            <svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M6 6l12 12M18 6L6 18"/></svg>
          </button>
        </div>
        <div class="garage__scroll" data-scroll>
          <section data-hero></section>
          <section class="garage__level" data-level></section>
          <section class="garage__cars" data-cars></section>
          <section class="garage__picker" data-picker></section>
        </div>
        <div class="garage__foot">
          <button type="button" class="garage__done" data-close>Fertig – passende Teile ansehen</button>
          <p class="garage__note">Deine Garage und dein Foto bleiben nur in diesem Browser gespeichert.</p>
        </div>
      `;

      this.$hero = this.panel.querySelector('[data-hero]');
      this.$level = this.panel.querySelector('[data-level]');
      this.$cars = this.panel.querySelector('[data-cars]');
      this.$picker = this.panel.querySelector('[data-picker]');
      document.body.append(this.backdrop, this.panel);
    }

    /* Darstellung ----------------------------------------------------------------- */
    render() {
      const car = store.activeCar();
      const vehicle = store.get();

      this.classList.toggle('has-vehicle', Boolean(vehicle));
      this.labelEl.textContent = vehicle
        ? (car.nick.trim() || vehicle.short)
        : 'Meine Garage';
      this.button.setAttribute('aria-label', vehicle ? `Meine Garage: ${vehicle.name}` : 'Meine Garage öffnen');

      let avatar = this.button.querySelector('.garage__avatar');
      const photo = car ? safePhoto(car.photo) : '';
      if (photo) {
        if (!avatar) {
          avatar = document.createElement('img');
          avatar.className = 'garage__avatar';
          avatar.alt = '';
          this.button.prepend(avatar);
        }
        avatar.src = photo;
      } else if (avatar) {
        avatar.remove();
      }
      this.classList.toggle('has-photo', Boolean(photo));

      this.renderHero(car, vehicle);
      this.renderLevel();
      this.renderCars();
      this.renderPicker();
      applyBadges();
    }

    renderHero(car, vehicle) {
      if (!car || !vehicle) {
        this.$hero.innerHTML = `
          <div class="garage__hero garage__hero--empty">
            <div class="garage__hero-media">${CAR_ART}</div>
            <div class="garage__hero-body">
              <p class="garage__kicker">Noch leer</p>
              <p class="garage__hero-title">Parke hier dein Auto</p>
              <p class="garage__hero-sub">Wähle unten dein BMW-Modell. Passende Teile werden dann im ganzen Shop markiert.</p>
            </div>
          </div>`;
        return;
      }

      const photo = safePhoto(car.photo);
      const code = vehicle.badge;
      const codeSize = code.length > 7 ? 46 : code.length > 4 ? 66 : 92;
      this.$hero.innerHTML = `
        <div class="garage__hero${photo ? ' has-photo' : ''}" data-hero-card>
          <div class="garage__hero-media">
            ${photo ? `<img class="garage__photo" src="${photo}" alt="">` : `<span class="garage__code" style="font-size:${codeSize}px" aria-hidden="true">${esc(code)}</span>${CAR_ART}`}
          </div>
          <div class="garage__hero-shade"></div>
          <div class="garage__hero-body">
            <p class="garage__kicker">Dein Fahrzeug</p>
            <label class="visually-hidden" for="garage-nick">Spitzname deines Autos</label>
            <input type="text" id="garage-nick" class="garage__nick" data-nick maxlength="24" placeholder="Gib deinem Auto einen Namen" value="${esc(car.nick)}" autocomplete="off">
            <p class="garage__hero-name">${esc(vehicle.name)}</p>
            ${vehicle.legacy ? '<p class="garage__tip">Tipp: Wähle über „Fahrzeug ändern“ deine Karosserieform, dann sind die Treffer genauer.</p>' : ''}
            <div class="garage__actions">
              <button type="button" class="garage__btn-pill garage__btn-pill--main" data-photo>${CAMERA_ICON}<span>${photo ? 'Foto ändern' : 'Foto hinzufügen'}</span></button>
              <button type="button" class="garage__btn-pill" data-change>Fahrzeug ändern</button>
              <button type="button" class="garage__btn-pill garage__btn-pill--quiet" data-remove>Entfernen</button>
            </div>
            <p class="garage__msg" data-msg hidden></p>
          </div>
          <input type="file" accept="image/*" hidden data-file>
        </div>`;
    }

    renderLevel() {
      const { stars, total, next } = store.level();
      const cars = store.cars();
      if (!cars.length) {
        this.$level.hidden = true;
        return;
      }
      this.$level.hidden = false;

      const pops = stars > this.lastStars;
      const starHtml = Array.from({ length: total }, (_, i) => `<span class="garage__star${i < stars ? ' is-on' : ''}${pops && i === stars - 1 ? ' is-new' : ''}">${STAR_ICON}</span>`).join('');
      this.$level.innerHTML = `
        <div class="garage__stars" role="img" aria-label="Garage-Level: ${stars} von ${total} Sternen">${starHtml}</div>
        <div class="garage__level-text">
          <p class="garage__level-title">Garage-Level ${stars}/${total}</p>
          <p class="garage__level-hint">${next ? `Nächster Stern: ${esc(next)}` : 'Volle Punktzahl – deine Garage ist komplett!'}</p>
        </div>`;

      if (pops) burst(this.panel.querySelector('[data-hero-card]') || this.$level);
      this.lastStars = stars;
    }

    renderCars() {
      const cars = store.cars();
      const active = store.activeCar();
      if (!cars.length) {
        this.$cars.innerHTML = '';
        this.$cars.hidden = true;
        return;
      }
      this.$cars.hidden = false;

      const items = cars.map((c) => {
        const v = store.vehicleOf(c);
        const photo = safePhoto(c.photo);
        const isActive = active && c.uid === active.uid;
        return `<button type="button" class="garage__car${isActive ? ' is-active' : ''}" data-car="${c.uid}" aria-pressed="${isActive}">
          <span class="garage__car-thumb">${photo ? `<img src="${photo}" alt="">` : esc(v.badge)}</span>
          <span class="garage__car-name">${esc(c.nick.trim() || v.short)}</span>
        </button>`;
      }).join('');

      const canAdd = cars.length < MAX_CARS;
      this.$cars.innerHTML = `
        <p class="garage__section-title">Meine Fahrzeuge</p>
        <div class="garage__car-row">
          ${items}
          ${canAdd ? '<button type="button" class="garage__car garage__car--add" data-add><span class="garage__car-thumb">+</span><span class="garage__car-name">Hinzufügen</span></button>' : ''}
        </div>`;
    }

    renderPicker() {
      const hasCars = store.cars().length > 0;
      const mode = hasCars ? this.pickerMode : 'add';
      if (!mode) {
        this.$picker.hidden = true;
        this.$picker.innerHTML = '';
        return;
      }
      this.$picker.hidden = false;

      const active = store.get();
      if (!this.brand || !BRANDS.includes(this.brand)) this.brand = (active && active.brand) || BRANDS[0];
      const groups = [...new Set(this.selectable().filter((v) => v.brand === this.brand).map((v) => v.group))];
      if (!this.tab || !groups.includes(this.tab)) {
        this.tab = active && active.brand === this.brand && groups.includes(active.group) ? active.group : groups[0];
      }

      const title = mode === 'replace' ? 'Fahrzeug ändern' : (hasCars ? 'Weiteres Fahrzeug hinzufügen' : 'Wähle dein Fahrzeug');
      const brands = BRANDS.map((b) => `<button type="button" class="garage__brandpill${b === this.brand && !this.term ? ' is-active' : ''}" data-brand-pick="${esc(b)}" aria-pressed="${b === this.brand && !this.term}">${esc(b)}</button>`).join('');
      const tabs = groups.map((g) => `<button type="button" role="tab" class="garage__tab${g === this.tab && !this.term ? ' is-active' : ''}" data-tab="${esc(g)}" aria-selected="${g === this.tab && !this.term}">${esc(g)}</button>`).join('');

      this.$picker.innerHTML = `
        <div class="garage__picker-head">
          <p class="garage__section-title">${title}</p>
          ${hasCars ? '<button type="button" class="garage__link" data-picker-close>Abbrechen</button>' : ''}
        </div>
        <div class="garage__search">
          <label class="visually-hidden" for="garage-search">Baureihe suchen</label>
          <input type="search" id="garage-search" class="garage__search-input" placeholder="Baureihe suchen, z. B. G20 oder 3er" autocomplete="off" value="${esc(this.term)}">
        </div>
        <div class="garage__brands" aria-label="Marke">${brands}</div>
        <div class="garage__tabs" role="tablist">${tabs}</div>
        <div class="garage__chips" data-chips></div>
        <p class="garage__empty" data-empty hidden>Nichts gefunden. <a href="/pages/contact">Schreib uns kurz</a> – wir prüfen die Passform.</p>`;
      this.fillChips();
    }

    // Alte, zusammengefasste Eintraege (legacy) sind nur waehlbar, solange sie schon in der Garage liegen
    selectable() {
      const owned = new Set(store.cars().map((c) => c.vehicleId));
      return VEHICLES.filter((v) => !v.legacy || owned.has(v.id));
    }

    fillChips() {
      const chips = this.$picker.querySelector('[data-chips]');
      if (!chips) return;
      const words = this.term.toLowerCase().split(/\s+/).filter(Boolean);
      const activeVehicle = store.get();
      const owned = new Set(store.cars().map((c) => c.vehicleId));

      const list = this.selectable().filter((v) => {
        if (!words.length) return v.brand === this.brand && v.group === this.tab;
        const hay = `${v.name} ${v.codes.join(' ')} ${v.group} ${v.brand}`.toLowerCase();
        return words.every((w) => hay.includes(w));
      });

      chips.innerHTML = list.map((v) => {
        const isActive = activeVehicle && v.id === activeVehicle.id;
        const isOwned = owned.has(v.id);
        return `<button type="button" class="garage__chip${isActive ? ' is-active' : ''}${isOwned && !isActive ? ' is-owned' : ''}" data-vehicle="${v.id}">${esc(v.label)}${isOwned ? '<span class="garage__chip-check" aria-hidden="true">✓</span>' : ''}</button>`;
      }).join('');
      this.$picker.querySelector('[data-empty]').hidden = list.length > 0;
    }

    /* Ereignisse ------------------------------------------------------------------ */
    onClick(e) {
      const t = e.target;
      const vehicleBtn = t.closest('[data-vehicle]');
      if (vehicleBtn) {
        this.chooseVehicle(vehicleBtn.dataset.vehicle);
        return;
      }
      const brandPick = t.closest('[data-brand-pick]');
      if (brandPick) {
        this.brand = brandPick.dataset.brandPick;
        this.tab = null;
        this.term = '';
        this.renderPicker();
        return;
      }
      const tab = t.closest('[data-tab]');
      if (tab) {
        this.tab = tab.dataset.tab;
        this.term = '';
        this.renderPicker();
        return;
      }
      const carBtn = t.closest('[data-car]');
      if (carBtn) { store.activate(carBtn.dataset.car); return; }
      if (t.closest('[data-add]')) { this.pickerMode = 'add'; this.renderPicker(); this.scrollTo(this.$picker); return; }
      if (t.closest('[data-change]')) { this.pickerMode = 'replace'; this.renderPicker(); this.scrollTo(this.$picker); return; }
      if (t.closest('[data-picker-close]')) { this.pickerMode = null; this.term = ''; this.renderPicker(); return; }
      if (t.closest('[data-photo]')) { this.panel.querySelector('[data-file]').click(); return; }
      if (t.closest('[data-remove]')) {
        const car = store.activeCar();
        if (car) store.remove(car.uid);
        return;
      }
      if (t.closest('[data-close]')) this.close(true);
    }

    onInput(e) {
      if (e.target.matches('[data-nick]')) {
        const car = store.activeCar();
        if (car) store.update(car.uid, { nick: e.target.value.slice(0, 24) }, true);
        return;
      }
      if (e.target.matches('.garage__search-input')) {
        this.term = e.target.value.trim();
        this.$picker.querySelectorAll('[data-brand-pick]').forEach((pill) => {
          const on = pill.dataset.brandPick === this.brand && !this.term;
          pill.classList.toggle('is-active', on);
          pill.setAttribute('aria-pressed', String(on));
        });
        this.$picker.querySelectorAll('[data-tab]').forEach((tab) => {
          const on = tab.dataset.tab === this.tab && !this.term;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', String(on));
        });
        this.fillChips();
      }
    }

    onChange(e) {
      if (e.target.matches('[data-nick]')) {
        const car = store.activeCar();
        if (car) store.update(car.uid, { nick: e.target.value.trim().slice(0, 24) });
        return;
      }
      if (e.target.matches('[data-file]')) this.handlePhoto(e.target);
    }

    chooseVehicle(id) {
      const mode = store.cars().length ? this.pickerMode : 'add';
      const car = store.activeCar();
      this.pickerMode = null;
      this.term = '';
      if (mode === 'replace' && car) store.replace(car.uid, id);
      else store.add(id);
      this.scrollTo(this.$hero);
      const hero = this.panel.querySelector('.garage__hero');
      if (hero && !reduceMotion()) hero.animate([{ transform: 'scale(.96)', opacity: 0.4 }, { transform: 'none', opacity: 1 }], { duration: 380, easing: 'cubic-bezier(.2,.9,.3,1.2)' });
    }

    async handlePhoto(input) {
      const file = input.files && input.files[0];
      input.value = '';
      const car = store.activeCar();
      if (!file || !car) return;

      try {
        const data = await processPhoto(file);
        const before = store.level().stars;
        const saved = store.update(car.uid, { photo: data });
        if (!saved) {
          store.update(car.uid, { photo: '' });
          this.showMessage('Speicher voll – das Foto konnte nicht gespeichert werden.');
          return;
        }
        burst(this.panel.querySelector('[data-hero-card]'));
        this.showMessage(store.level().stars > before ? 'Foto gespeichert – neuer Stern!' : 'Foto gespeichert.');
      } catch (err) {
        this.showMessage(err.message || 'Das Foto konnte nicht verarbeitet werden.');
      }
    }

    showMessage(text) {
      const msg = this.panel.querySelector('[data-msg]');
      if (!msg) return;
      msg.textContent = text;
      msg.hidden = false;
      clearTimeout(this.msgTimer);
      this.msgTimer = setTimeout(() => { msg.hidden = true; }, 3200);
    }

    scrollTo(el) {
      if (el && el.scrollIntoView) el.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'nearest' });
    }

    /* Oeffnen / Schliessen ------------------------------------------------------------ */
    position() {
      if (window.matchMedia('(max-width: 768px)').matches) {
        this.panel.style.top = '';
        this.panel.style.right = '';
        return;
      }
      const rect = this.button.getBoundingClientRect();
      this.panel.style.top = `${Math.round(rect.bottom + 10)}px`;
      this.panel.style.right = `${Math.max(12, Math.round(window.innerWidth - rect.right))}px`;
    }

    toggle() {
      if (this.open) this.close(true); else this.show();
    }

    show() {
      this.open = true;
      this.pickerMode = null;
      this.term = '';
      this.panel.hidden = false;
      this.backdrop.hidden = false;
      this.button.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('garage-open');
      this.renderPicker();
      this.position();
      const first = this.panel.querySelector('.garage__search-input') || this.panel.querySelector('.garage__close');
      if (first) first.focus({ preventScroll: true });
    }

    close(returnFocus) {
      this.open = false;
      this.panel.hidden = true;
      this.backdrop.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('garage-open');
      if (returnFocus) this.button.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('garage-widget')) customElements.define('garage-widget', GarageWidget);

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-fitment-open]')) store.open();
  });

  /* Karten, die spaeter nachgeladen werden (Filter, Seiten, Karussells) */
  const start = () => {
    applyBadges();
    new MutationObserver(scheduleBadges).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
